export const DOWNLOAD_REPORT_REQUEST = 'DOWNLOAD_REPORT_REQUEST';
export const DOWNLOAD_REPORT_SUCCESS = 'DOWNLOAD_REPORT_SUCCESS';
export const DOWNLOAD_REPORT_ERROR = 'DOWNLOAD_REPORT_ERROR';

export const GET_VEHICLE_STATS_REQUEST = 'GET_VEHICLE_STATS_REQUEST';
export const GET_VEHICLE_STATS_SUCCESS = 'GET_VEHICLE_STATS_SUCCESS';
export const GET_VEHICLE_STATS_ERROR = 'GET_VEHICLE_STATS_ERROR';